export default __webpack_public_path__ + "static/adver-050da85cec89d0b3c64eecf63e65584f.png";